import { CATEGORY_FROM_FLA, CODE, DESCRIPTION, INCLUDE_IN_EMAIL, INCLUDE_IN_REPORTING, IS_REVIEW_COMPLETED, THREE_PS_DATA_UID, UPDATED_BY, USER_DEFINED_DESCRIPTION, USER_DEFINED_EMAIL_DESCRIPTION } from "../../threePsCodes.constants";
import { TColumnConfigItem } from "./threePsCodeTable.types";

export const HIDDEN_COLUMNS = new Set([
    THREE_PS_DATA_UID,
]);

export const COLUMN_CONFIG: TColumnConfigItem[] = [
    { key: CODE, title: 'Code', width: 120 },
    { key: DESCRIPTION, title: 'Description', width: 500 },
    { key: INCLUDE_IN_EMAIL, title: 'Include in Email', width: 100 },
    {
        key: USER_DEFINED_EMAIL_DESCRIPTION,
        title: 'Category to Display in Email',
        width: 150,
    },
    { key: INCLUDE_IN_REPORTING, title: 'Include in Reporting', width: 100 },
    {
        key: USER_DEFINED_DESCRIPTION,
        title: 'Category to Display in Reporting',
        width: 150,
    },
    { key: IS_REVIEW_COMPLETED, title: 'Mark as Reviewed', width: 100 },
    { key: UPDATED_BY, title: 'Last Updated', width: 190 },
    { key: CATEGORY_FROM_FLA, title: 'Category from FLA', width: 150 },
];